import { render } from "./NoteEditField.vue?vue&type=template&id=c113d4a2"
import script from "./NoteEditField.vue?vue&type=script&lang=js"
export * from "./NoteEditField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__